import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import UserDetail from './UserDetail';
import useDetailHandler from '../../hooks/useDetailHandler';
import DateTime, { DATETIME } from '../DateTime';
import { userPropertiesType, userType } from '../../types';
import './_styles_/UserRow.css';
import { getAllRoles } from '../../utils/UserRoles';
import { onActionKey } from '../../utils';

export const getValueMapping = (t) => {
    const roles = getAllRoles().map((role) => ({ from: role.serverRole, to: role.translate(t) }));
    return {
        suspended: [
            {
                from: true,
                to: t('misc.yes'),
            },
            {
                from: false,
                to: t('misc.no'),
            },
        ],
        active: [
            {
                from: true,
                to: t('misc.yes'),
            },
            {
                from: false,
                to: t('misc.no'),
            },
        ],
        roles,
    };
};

UserRow.propTypes = {
    user: userType.isRequired,
    userProps: userPropertiesType.isRequired,
};

function UserRow(props) {
    const {
        user,
        userProps,
    } = props;
    const { t } = useTranslation();
    const { isDetailVisible, toggleDetail } = useDetailHandler(user.id);
    return (
        <>
            <div className="rich-list-row user-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="user-header--values--user-id">{user.racf}</div>
                <div className="user-header--values--name">{user.name}</div>
                <div className="user-header--values--email">{user.email}</div>
                <div className="user-header--values--last-login-time"><DateTime value={user.lastSigninTime} format={DATETIME} /></div>
                <div className="user-header--values--suspended">{user.suspended ? t('misc.yes') : t('misc.no')}</div>
                <div className="user-header--values--active">{user.active ? t('misc.yes') : t('misc.no')}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && <UserDetail id={user.id} userProps={userProps} />}
        </>
    );
}

export default UserRow;
